import { FooterLinkType } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'

export const footerLinks: (t: ContextApi['t']) => FooterLinkType[] = (t) => [
  {
    label: t('About'),
    items: [
      {
        label: t('Contact'),
        href: 'https://docs.cheeseswap.financial/contact-us',
      },
      {
        label: t('Brand'),
        href: 'https://docs.cheeseswap.financial/brand',
      },
      {
        label: t('Blog'),
        href: 'https://medium.com/cheeseswap',
      },
      {
        label: t('Community'),
        href: 'https://docs.cheeseswap.financial/contact-us/telegram',
      },
      {
        label: t('CHEESE token'),
        href: 'https://docs.cheeseswap.financial/tokenomics/cake',
      },
    ],
  },
  {
    label: t('Help'),
    items: [
      {
        label: t('Customer Support'),
        href: 'https://docs.cheeseswap.financial/contact-us/customer-support',
      },
      {
        label: t('Troubleshooting'),
        href: 'https://docs.cheeseswap.financial/help/troubleshooting',
      },
      {
        label: t('Guides'),
        href: 'https://docs.cheeseswap.financial/get-started',
      },
    ],
  },
  {
    label: t('Developers'),
    items: [
      {
        label: 'Github',
        href: 'https://github.com/cheeseswap',
      },
      {
        label: t('Documentation'),
        href: 'https://docs.cheeseswap.financial',
      },
      {
        label: t('Bug Bounty'),
        href: 'https://app.gitbook.com/@cheeseswap-1/s/cheeseswap/code/bug-bounty',
      },
      {
        label: t('Audits'),
        href: 'https://docs.cheeseswap.financial/help/faq#is-cheeseswap-safe-has-cheeseswap-been-audited',
      },
      {
        label: t('Careers'),
        href: 'https://docs.cheeseswap.financial/hiring/become-a-chef',
      },
    ],
  },
]
